import React from "react";
import { GripVertical, Inbox } from "lucide-react";
import { PRIORITY_META } from "@/lib/ui";
import { fmtDur } from "@/lib/time";

// Drag a task into the grid → TaskBlock. Native HTML5 drag so it can cross into the pointer-driven grid.
export default function UnscheduledPanel({ tasks, loading, onOpenTask, onDropUnschedule }) {
  return (
    <aside className="rounded-2xl border border-border bg-card flex flex-col min-h-[240px]" data-testid="unscheduled-panel"
      onDragOver={(e) => { if (e.dataTransfer.types.includes("application/airtime-block")) e.preventDefault(); }}
      onDrop={(e) => { const raw = e.dataTransfer.getData("application/airtime-block"); if (raw) onDropUnschedule?.(JSON.parse(raw)); }}>
      <div className="px-4 pt-4 pb-2 flex items-center justify-between">
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Tâches non planifiées</div>
        <span className="font-mono text-[10px] text-muted-foreground" data-testid="unscheduled-count">{tasks.length}</span>
      </div>
      <div className="flex-1 overflow-y-auto airtime-scroll px-3 pb-3 space-y-1.5" style={{ maxHeight: "calc(100vh - 330px)" }}>
        {!loading && tasks.length === 0 && (
          <div className="flex flex-col items-center text-center py-8 text-muted-foreground"><Inbox className="w-6 h-6 mb-2 opacity-50" /><div className="text-xs">Tout est planifié.</div></div>
        )}
        {tasks.map((t) => (
          <div key={t.id} draggable data-testid={`unscheduled-task-${t.id}`}
            onDragStart={(e) => { e.dataTransfer.setData("application/airtime-task", JSON.stringify({ id: t.id, title: t.title, estimated_minutes: t.estimated_minutes })); e.dataTransfer.effectAllowed = "move"; }}
            onClick={() => onOpenTask(t.id)}
            className="group flex items-start gap-2 rounded-xl border border-border bg-background/40 px-2.5 py-2 cursor-grab active:cursor-grabbing hover:border-primary/40 transition-colors">
            <GripVertical className="w-4 h-4 mt-0.5 text-muted-foreground/50 group-hover:text-muted-foreground shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm leading-snug truncate">{t.title}</div>
              <div className="flex items-center gap-2 mt-1">
                <span className={`font-mono text-[9px] px-1.5 py-0.5 rounded-full border ${PRIORITY_META[t.priority]?.cls || ""}`}>{PRIORITY_META[t.priority]?.label || t.priority}</span>
                <span className="font-mono text-[10px] text-muted-foreground">{fmtDur(t.estimated_minutes || 60)}</span>
                {t.project && t.project !== "Autre" && <span className="text-[10px] text-muted-foreground truncate">· {t.project}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="px-4 py-2.5 border-t border-border text-[10px] text-muted-foreground">Glisse une tâche dans l'agenda pour la planifier · glisse un bloc hors de l'agenda pour le déplanifier.</div>
    </aside>
  );
}
